import React, { useMemo } from "react";
import { SelectOption } from "global";
import { FormInputSelect } from "components/form";
import { IconButton, Stack } from "@mui/material";
import { RemoveCircle } from "@mui/icons-material";
import { allFacts } from "../../constants";

interface Props {
  onRemove?: VoidFunction;
  addedCriteriaTypes: string[];
  currentValue: string | undefined;
  onChange: (nextValue: string) => void;
}

export const CriteriaHeadCell = ({ onRemove, onChange, currentValue, addedCriteriaTypes }: Props) => {
  const options = useMemo(() => {
    const currentOption = allFacts.find(fact => fact.value === currentValue) as SelectOption;

    return [
      currentOption,
      ...allFacts.filter(({ value }) => !addedCriteriaTypes.includes(value)),
    ] satisfies SelectOption[];
  }, [addedCriteriaTypes, currentValue]);

  return (
    <Stack direction="row" gap="0.5rem" width="100%">
      {onRemove && (
        <IconButton size="small" onClick={onRemove}>
          <RemoveCircle color="error" />
        </IconButton>
      )}

      <FormInputSelect variant="outlined" size="small" value={currentValue} onChange={onChange} options={options} />
    </Stack>
  );
};
